
import { openWithEntry } from '@/utils/url'

export default {
    // props: ['source'],
    data() {
        return {
            banners: [],
            screenWidth: 0,
            screenHeight: 0

        }
    },
    mounted() {
        this.getSlideList()
        this.getScreenSize();

    },
    methods: {
        async getSlideList() {
            //获取首页轮播图
            if (!this.source) {
                let res = await this.$global.slidelist({identifier:this.$route.path=='/'?'pc_index':'pc_video'})
                res.code == '200' ? this.banners = res.data: ''

               
            } else {
                this.banners = this.source
               
            }
           
            
        },
        jumpAddress(url) {
            openWithEntry(url, 'home_banner')
        },
        getScreenSize() {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
    }
    }
}
